export const RESET = "RESET_STORE";
export const CLEAR = "CLEAR_LOGIN_STATE";
export const LOGOUT = "LOGOUT";
export const UPDATE_INFO = "UPDATE_INFO";
